import { render, staticRenderFns } from "./RoomGroup.vue?vue&type=template&id=194846d2"
import script from "./RoomGroup.vue?vue&type=script&lang=js"
export * from "./RoomGroup.vue?vue&type=script&lang=js"
import style0 from "./RoomGroup.vue?vue&type=style&index=0&id=194846d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports